module.exports = __webpack_public_path__ + "static/img/m_global_flow_step6@3x.bd029dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m_global_flow_step6@3x.png
// module id = yGXi
// module chunks = 1